import colors from '@/utils/theme/colors'

import { PRIMARY_COLOR_STORAGE_KEY } from './constants'

export const getStoredPrimaryColor = (fallbackColor: string) => {
  if (globalThis.window === undefined) return fallbackColor

  const storedColor = globalThis.localStorage.getItem(PRIMARY_COLOR_STORAGE_KEY)
  if (storedColor && storedColor in colors) return storedColor

  return fallbackColor
}
